import styled from 'styled-components';

import { DangerousInnerHTML } from '@/shared/components/dangerous-inner-html';
import { GamePad } from '@/shared/components/icons';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  min-width: 25rem;
  margin: 0 auto 6rem;
`;

export const Title = styled.h3`
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.25rem;
  text-align: center;
  color: #2d2d30;
`;

export const Icon = styled(GamePad)`
  margin-top: 3rem;
  align-self: center;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
`;

export const Content = styled(DangerousInnerHTML)`
  font-size: 0.9rem;
  line-height: 1.25rem;
  text-align: center;
  color: #3a3a3a;
  max-width: 25rem;
`;
